import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/mobile.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import { consumeAppTokenFromUrl, takeAppSsoPending } from './utils/appSso'
import { getMe } from './api/auth'
import { useUserStore } from './stores/user'

/** App WebView / 刘海屏：给顶栏留出状态栏空间 */
;(function markAppShell() {
  try {
    const q = new URLSearchParams(window.location.search || '')
    const ua = navigator.userAgent || ''
    const isApp =
      q.get('app') === '1' ||
      /Html5Plus|uni-app|StreamApp/i.test(ua)
    if (isApp) {
      document.documentElement.classList.add('in-app')
    }
    document.documentElement.classList.add('has-safe-top')
  } catch (e) {}
})()

consumeAppTokenFromUrl()

async function hydrateUserSession(userStore) {
  if (!userStore.token) return
  try {
    const me = await getMe()
    userStore.setUserInfo(me)
  } catch (err) {
    // 仅 token 真正失效时清会话；网络抖动保留本地登录态
    if (err?.status === 401) {
      userStore.logout()
    }
  }
}

async function bootstrap() {
  const app = createApp(App)

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(createPinia())

  const userStore = useUserStore()
  const ssoPending = takeAppSsoPending()
  if (userStore.token && (ssoPending || !userStore.userInfo?.id)) {
    await hydrateUserSession(userStore)
  }

  app.use(router)
  app.use(ElementPlus)
  app.mount('#app')
}

bootstrap()
